import React, { FC } from 'react';
import { Control, UseFormWatch } from 'react-hook-form';
import { ReportConfigDto } from '@thingslog/repositories';

interface AlarmReportSettingsFormProps {
  control: Control<ReportConfigDto>;
  watch: UseFormWatch<ReportConfigDto>;
}

const AlarmReportSettingsForm: FC<AlarmReportSettingsFormProps> = (): React.ReactElement | null => {
  // No additional settings for alarm report
  return null;
};

export default AlarmReportSettingsForm;
